import SignupContainer from "containers/Signup/SignupContainer";
import React, { Fragment } from "react";
// import Header from "../../components/common/Header";
// import Footer from "../../components/common/Footer";
// import LoginContainer from "../../containers/Login/LoginContainer.js";

export default function SignUpPage() {
  return (
    <Fragment>
      {/* <Header isFromPlanListing={true} /> */}
      <div className="login_page">
        <SignupContainer />
      </div>
      {/* <Footer /> */}
    </Fragment>
  );
}
